export enum QuestionEnum {
    SERVICE = "service",
    ORDER = "order",
}